import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { ServiceAreasSection } from "@/components/ServiceAreasSection";
import { Reveal } from "@/components/Reveal";
import { CTABand } from "@/components/CTABand";
import { IMAGES } from "@/content/site";

export default function ServiceAreasPage() {
  return (
    <>
      <SEO
        title="Pool Service Areas in Pinellas County FL | Clearwater, St. Petersburg, Largo & More"
        description="Point of Pines Pools & Service provides weekly pool service across all of Pinellas County FL — Clearwater, St. Petersburg, Largo, Seminole, Dunedin, Palm Harbor, the beaches and beyond."
        path="/service-areas/"
      />
      <PageHero
        overline="Where We Work"
        title="Pool Service Across"
        accent="All of Pinellas County"
        description="We're a local company with local routes — not a franchise dispatching from three counties away. If your pool is in Pinellas, we can take care of it."
        image={IMAGES.oceanfrontPool}
        imageAlt="Sparkling oceanfront pool on the Pinellas County Florida coast serviced by Point of Pines Pools"
      />

      <ServiceAreasSection />

      <section data-testid="areas-local-note-section" className="py-16 sm:py-24 bg-shell">
        <div className="px-4 sm:px-6 lg:px-12 max-w-3xl mx-auto text-center">
          <Reveal>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-navy">
              One county. One standard of care.
            </h2>
            <p className="mt-5 text-base text-slate-600 leading-relaxed">
              Beach pools fight salt air and sand. Inland pools fight oak pollen and storm debris.
              Shaded pools in Safety Harbor behave nothing like sun-baked pools in Seminole. We
              adjust chemistry and care for the conditions on your street — because we work on
              pools in your neighborhood every week.
            </p>
            <p className="mt-4 text-base text-slate-600 leading-relaxed">
              Select your city above for details about pool service in your area, or just reach out
              — we&apos;ll confirm service for your address right away.
            </p>
          </Reveal>
        </div>
      </section>

      <CTABand
        title="Is your pool on our route?"
        text="Almost certainly — we serve every community in Pinellas County. Request a quote and we'll confirm your service day."
      />
    </>
  );
}
